import React, { useEffect, useState } from "react";
import "./ConnectWallet.css";
import ConnectWallet from "../ConnectWallet/ConnectWallet";
import useUserInfo from "../../Hooks/useUserInfo";
import ConnectWalletPage from "../../Pages/ConnectWallet/ConnectWalletPage";
import Tv from "../Tv/Tv";
import cancelIcon from "../../assets/Task/cancelicon.svg";
import { useAudio } from "../../Providers/AudioProvider";
import { getUserDetails1 } from "../../apis/user";
import { logPageView } from "../../components/analytics";


const Info = () => {
  const { watchScreen, userDetails, updateUserInfo, updatewatchScreenInfo } =
    useUserInfo();
  const playClick = useAudio();

  const goToThePage = (component, name) => {
    updateUserInfo((prev) => {
      return {
        ...prev,
        ...{
          currentComponent: component,
          currentComponentText: name,
          lastComponent: userDetails.currentComponent,
          lastComponentText: userDetails.currentComponentText,
          isMenu: false,
        },
      };
    });
    playClick();
  };
  useEffect(() => {
    logPageView("Connectwallet ", "Wallet Page");
  }, []);
  const getUserDetailsOnly = async () => {
    let userDetails1;
    try {
      userDetails1 = await getUserDetails1(
        userDetails?.userDetails?.telegramId
      );
    } catch (error) {
      console.error("Error in updating or fetching user details:", error);
    }
    // Update state after both async calls are completed
    if (userDetails) {
      updateUserInfo((prev) => ({
        ...prev,
        userDetails: userDetails1,
      }));
      updatewatchScreenInfo((prev) => ({
        ...prev,
        boostersList: userDetails1?.boosters,
        totalReward: userDetails1?.balanceRewards,
        tapPoints: 0,
        booster: false,
        boosterSec: 0,
        boosterPoints: 0,
        boosterDetails: {},
        watchSec: 0,
      }));
    }
    return userDetails;
  };
  const toogleMenu = () => {
    playClick();
    if (!watchScreen.booster) {
      const data = getUserDetailsOnly().then(() => {
        updateUserInfo((prev) => ({
          ...prev,
          isPlay: false,
          currentComponent: Tv,
          currentComponentText: "TVPage",
          lastComponent: userDetails?.userDetails.currentComponent,
          lastComponentText: userDetails?.userDetails.currentComponentText,
          isMenu: false,
          menuCount: userDetails?.userDetails?.menuCount + 1,
        }));
        // goToThePage(Battle, "BattlePage");
      });
    } else {
      goToThePage(Tv, "TVPage");
    }
  };

  return (
    <div className="info-img">
      <img
        onClick={() => {
          toogleMenu();
        }}
        src='https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg'
        className="cancel-imgpoints"
        style={{ cursor: "pointer", pointerEvents: "all" }}
      />
      <div
        className="menupointer"
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          alignItems: "center",
          // justifyContent: "center",
          marginTop: "100px",
          flexDirection: "column",
          pointerEvents: "all",
        }}
        onClick={() => {
          goToThePage(ConnectWallet, "ConnectWalletPage");
        }}
      >
        <div
          style={{
            // maxWidth: "380px",
            width: "100%",
          }}
        >
          <div className="phase-details">
              <h4 className="airdrop-tasks">AIRDROP TASKS</h4>
              <h4 className="airdrop">
                Get ready for upcoming tasks! Soon, you'll see a list of
                challenges below. Complete them to qualify for the Airdrop
              </h4>
              <br />
              <ConnectWalletPage></ConnectWalletPage>
            </div>
        </div>
      </div>
    </div>
  );
};

export default Info;
